import styled from '@emotion/styled';

import { customPalette } from '../../../styles/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${customPalette.accent.main};
  width: 100%;
  height: 80px;
  padding: 0 24px;

  @media (min-width: 1200px) {
    background-color: ${customPalette.accent.white};
    border-bottom: 1px solid ${customPalette.grey[200]};
  }
`;

export const LoginButton = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
  margin-right: 0;

  @media (min-width: 1200px) {
    position: absolute;
    right: 0;
    margin-right: 24px;
  }
`;

export const StyledLogo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  svg {
    padding-right: 10px;
    height: 56px;
  }

  @media (min-width: 1200px) {
    display: none;
  }
`;

export const LogoText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AppTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${customPalette.accent.white};

  @media (min-width: 1200px) {
    color: ${customPalette.accent.main};
  }
`;

export const Subtitle = styled.span`
  font-size: 12px;
  color: ${customPalette.accent.white};

  @media (min-width: 1200px) {
    color: ${customPalette.accent.main};
  }
`;
